export const DATASOURCES_SETTING = 'datasources';
